const DataNotFound = ({ className, text = "Data tidak ada" }) => {
  return (
    <p className={`py-3 text-center text-gray-300 ${className}`}>{text}</p>
  );
};

export default DataNotFound;
